'use strict';

Object.defineProperty(exports, '__esModule', {
     value: true
});
exports['default'] = RunConfig;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modulesAppDefinitions = require('../modules/app.definitions');

var _modulesAppDefinitions2 = _interopRequireDefault(_modulesAppDefinitions);

function RunConfig($rootScope, AppDefinitions) {
     //$rootScope.APP = AppDefinitions;
}

RunConfig.$inject = ['$rootScope'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/config/run.js
 ** module id = 7
 ** module chunks = 0
 **/